<template lang="pug">
.home
  listagem-processo-fisico
</template>

<script>
import ListagemProcessoFisico from './processoFisico/ListagemProcessoFisico'
export default {
  components: {
    ListagemProcessoFisico
  }
}

</script>

<style lang="scss" scoped>
.home {
  width: 100%
}
</style>



// WEBPACK FOOTER //
// src/screens/financeiro/Home.vue